import React, { useState, useEffect } from 'react'
import StudentForm from './StudentForm/StudentForm'
import { useParams } from '@tanstack/react-router'
import { Row, Button, Col } from 'react-bootstrap'
import { api } from '../../shared/ApiProvider'

export default function StudentAndEdFusion() {
  const { id } = useParams({ from: '/student/$id' })
  const [student, setStudent] = useState(undefined)
  const [edFusionStudent, setEdFusionStudent] = useState({})

  useEffect(() => {
    api.get(`/student/${id}`).then(response => {
      setStudent(response.data)
    })
  }, [id])

  return (
    <Row>
      <Col>{student ? <StudentForm student={student} /> : <h6 className="text-center mt-4">Loading...</h6>}</Col>
    </Row>
  )
}
